import { useEffect, useRef } from 'react';

// Roll Animation Popup Component
export const RollAnimationPopup = ({ onClose }) => {
    const videoRef = useRef(null);
  
    useEffect(() => {
      if (videoRef.current) {
        videoRef.current.play().catch(e => console.log("Video play failed:", e));
        
        // Loop the video until we close
        const handleEnded = () => {
          if (videoRef.current) {
            videoRef.current.currentTime = 0;
            videoRef.current.play();
          }
        };
        
        videoRef.current.addEventListener('ended', handleEnded);
        
        return () => {
          if (videoRef.current) {
            videoRef.current.removeEventListener('ended', handleEnded);
            videoRef.current.pause();
          }
        };
      }
    }, []);
  
    return (
      <div className="popup-overlay">
        <div className="roll-animation-popup">
          <div className="roll-animation-header">
            <h2><img 
                      src={`${process.env.PUBLIC_URL}/dice/6.png`} 
                      alt={`Dice 6`}
                      className="dice-title-image"
                    /> Rolling Dice... <img 
                    src={`${process.env.PUBLIC_URL}/dice/9.png`} 
                    alt={`Dice 9`}
                    className="dice-title-image"
                  /></h2>
            <p>Waiting for VRF randomness result...</p>
          </div>
          
          <div className="roll-video-container">
            <video 
              ref={videoRef}
              src={`${process.env.PUBLIC_URL}/dice/roll.mp4`} 
              className="roll-video"
              muted
              playsInline
              autoPlay
            />
          </div>
          
          <div className="roll-animation-footer">
            <p className="rolling-text">The dice are tumbling through the blockchain...</p>
            <button className="popup-action-btn" onClick={onClose}>
              Cancel Roll
            </button>
          </div>
        </div>
      </div>
    );
  };